// extracted by mini-css-extract-plugin
export default {"contentC":"Background_contentC__Pmbbk","bgCircle":"Background_bgCircle__A5X2i","bgHouses":"Background_bgHouses__w9hEv"};